import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-version-two',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
